import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import NavBar from "@/components/NavBar";
import CartDrawer from "@/components/CartDrawer";
import Footer from "@/components/Footer";
import EmailPopup from "@/components/EmailPopup";

import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import LookbookPage from "@/pages/LookbookPage";
import StoryPage from "@/pages/StoryPage";
import SuccessPage from "@/pages/SuccessPage";
import AdminPage from "@/pages/AdminPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AccountPage from "@/pages/AccountPage";

import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { initMetaPixel, trackPageView } from "@/lib/metaPixel";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const MetaPixelTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => { initMetaPixel(); }, []);
  useEffect(() => { trackPageView(); }, [pathname, search]);
  return null;
};

const Layout = () => (
  <div className="App">
    <NavBar />
    <CartDrawer />
    <main>
      <Routes>
        <Route path="/" element={<ShopPage />} />
        <Route path="/product/:slug" element={<ProductPage />} />
        <Route path="/lookbook" element={<LookbookPage />} />
        <Route path="/story" element={<StoryPage />} />
        <Route path="/cart" element={<ShopPage />} />
        <Route path="/checkout/success" element={<SuccessPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<ShopPage />} />
      </Routes>
    </main>
    <Footer />
    <EmailPopup />
  </div>
);

function App() {
  return (
    <>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1C1914",
            color: "#FFFDF5",
            border: "2px solid #1C1914",
            borderRadius: 0,
            fontFamily: "'Work Sans', sans-serif",
          },
        }}
      />
      <CartProvider>
        <BrowserRouter>
          <AuthProvider>
            <ScrollToTop />
            <MetaPixelTracker />
            <Layout />
          </AuthProvider>
        </BrowserRouter>
      </CartProvider>
    </>
  );
}

export default App;
